import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const clean = (m) => String(m).replace(/^Value error,\s*/, "");

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return clean(detail);
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? clean(d.msg) : JSON.stringify(d))).join(" ");
  if (detail && typeof detail.msg === "string") return clean(detail.msg);
  return e?.message || "Une erreur est survenue.";
}

// Uniquement les visuels fournis par SHRAL'AUTO (aucune photo de banque d'images)
const ASSETS = "https://customer-assets-m6fa6gv7.emergentagent.net/job_shral-performance/artifacts/";

export const BRAND = {
  logo: ASSETS + "v655zmd9_IMG_5408.jpeg",
  posterMeca: ASSETS + "vobapx4i_IMG_5409.jpeg",
  posterRepro: ASSETS + "heqxbf9j_IMG_5410.jpeg",
  adblue: ASSETS + "a7elqwku_12885CBA-D87F-4A2A-A8A2-9C0ED1C580B8.jpeg",
  p207: ASSETS + "n38n6yjb_8F2BEB08-0D09-4C66-BD54-8C3A60128FAB.png",
  p308: ASSETS + "zuw5ukmp_153413F1-3529-44A3-8967-6DE1779FD153.png",
  heroBanner: ASSETS + "f80e78436f0f8b29_A1FEE72D-3FD1-4EB4-961F-D3DBABF1328B.png",
};
// Alias utilisés par les pages
BRAND.hero = BRAND.posterMeca;
BRAND.workshop = BRAND.posterRepro;
BRAND.night = BRAND.adblue;
BRAND.tools = BRAND.p207;
BRAND.diag = BRAND.p308;

export const MONTHS_FR = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
export const DAYS_FR = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

export function formatDateFr(iso) {
  if (!iso) return "";
  const d = new Date(`${iso}T12:00:00`);
  return d.toLocaleDateString("fr-FR", { weekday: "long", day: "2-digit", month: "long", year: "numeric" });
}
